<template>
	<q-page>
		<div class="row" v-if="!isLoading">
			<div class="col">
				<h4>{{ $t('speciesCount', {count: filteredSpeciesList.length}) }}</h4>
			</div>
		</div>

		<div class="row" style="max-width: 340px;">
			<div class="col-2">
				<div class="column">
					<div class="col">
						<span class="text-overline">{{ $t('filter') }}</span>
					</div>
					<div class="col">
						<q-btn icon="filter_list"
							   color="primary"
							   @click="displayGalleryFilters = !displayGalleryFilters"
							   :class="{'bg-primary' : displayGalleryFilters, 'text-white' : displayGalleryFilters}"
							   outline
							   dense
						/>
					</div>
				</div>
			</div>

			<div class="col-7">
				<div class="column">
					<div class="col">
						<span class="text-overline">{{ $t('sorting') }}</span>
					</div>
					<div class="col">
						<q-btn v-if="galleryView === GALLERY_VIEW.TEASER"
							   color="primary"
							   :label="$t('label.color')"
							   :icon="sortingIcon"
							   @click="changeGallerySortingDirection"
							   no-caps
						/>
						<q-btn-dropdown v-if="galleryView === GALLERY_VIEW.LIST"
										split
										color="primary"
										:label="$t('button.listtype.' + gallerySorting)"
										:icon="sortingIcon"
										@click="changeGallerySortingDirection"
										no-caps
						>
							<q-list>
								<q-item clickable v-close-popup @click="setGallerySorting(GALLERY_SORTING.NAME)">
									<q-item-section>
										<q-item-label>{{ $t('button.listtype.name') }}</q-item-label>
									</q-item-section>
								</q-item>
								<q-item clickable v-close-popup @click="setGallerySorting(GALLERY_SORTING.TRADENAME)">
									<q-item-section>
										<q-item-label>{{ $t('button.listtype.tradename') }}</q-item-label>
									</q-item-section>
								</q-item>
								<q-item clickable v-close-popup @click="setGallerySorting(GALLERY_SORTING.BOTANICALNAME)">
									<q-item-section>
										<q-item-label>{{ $t('button.listtype.botanicalname') }}</q-item-label>
									</q-item-section>
								</q-item>
							</q-list>
						</q-btn-dropdown>
					</div>
				</div>
			</div>

			<div class="col-3">
				<div class="column">
					<div class="col">
						<span class="text-overline">{{ $t('viewType') }}</span>
					</div>
					<div class="col">
						<q-tabs :value="galleryView"
								active-color="white"
								active-bg-color="primary"
								align="left"
								:breakpoint="0"
								outline shrink dense
						>
							<q-tab @click="setGalleryView(GALLERY_VIEW.TEASER)"
								   :name="GALLERY_VIEW.TEASER"
								   icon="view_module"
								   color="primary"
								   class="gallery-tab gallery-tab-left"
							/>
							<q-tab @click="setGalleryView(GALLERY_VIEW.LIST)"
								   :name="GALLERY_VIEW.LIST"
								   icon="view_column"
								   color="primary"
								   class="gallery-tab gallery-tab-right"
							/>
						</q-tabs>
					</div>
				</div>
			</div>
		</div>

		<q-slide-transition>
			<gallery-filters v-if="displayGalleryFilters" class="q-mt-md"/>
		</q-slide-transition>

		<q-spinner-cube v-if="isLoading" color="primary" size="3em" class="absolute-center"/>

		<q-tab-panels :value="galleryView" class="q-mt-lg q-pa-none bg-transparent" animated keep-alive>
			<q-tab-panel :name="GALLERY_VIEW.TEASER" class="q-pa-none">
				<GalleryTeaserList/>
			</q-tab-panel>
			<q-tab-panel :name="GALLERY_VIEW.LIST" class="q-pa-none">
				<GalleryList/>
			</q-tab-panel>
		</q-tab-panels>
	</q-page>
</template>

<script>
	import {GALLERY_SORTING, GALLERY_VIEW} from "@/common/constants";
	import GalleryFilters from "@/components/gallery/GalleryFilters";
	import GalleryTeaserList from "@/components/gallery/GalleryTeaserList";
	import {SET_GALLERY_SORTING, SET_GALLERY_SORTING_DIRECTION, SET_GALLERY_VIEW} from "@/store/mutations.type";
	import GalleryList from "@/components/gallery/GalleryList";
	import {mapGetters} from "vuex";

	export default {
		name: "Gallery",
		components: {GalleryList, GalleryTeaserList, GalleryFilters},
		data() {
			return {
				GALLERY_VIEW,
				GALLERY_SORTING,
				displayGalleryFilters: false
			}
		},
		computed: {
			...mapGetters(['galleryView', 'gallerySorting', 'gallerySortingDirection', 'isLoading', 'filteredSpeciesList']),
			sortingIcon() {
				return this.gallerySortingDirection ? 'arrow_downward' : 'arrow_upward';
			}
		},
		methods: {
			setGalleryView(type) {
				this.$store.commit(SET_GALLERY_VIEW, type);
			},
			setGallerySorting(sorting) {
				this.$store.commit(SET_GALLERY_SORTING, sorting);
			},
			changeGallerySortingDirection() {
				this.$store.commit(SET_GALLERY_SORTING_DIRECTION, !this.gallerySortingDirection);
			}
		}
	}
</script>

<style lang="scss">
	.q-tab.gallery-tab {
		border-color: var(--q-color-primary);
		border-style: solid;
		border-width: 1px;
		max-width: 40px;

		.q-tab__indicator {
			display: none;
		}

		.gallery-tab-left {
			border-right-width: 0;
		}

		.gallery-tab-right {
			border-left-width: 0;
		}
	}
</style>